var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelMail14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m5.906 7.21.642.474c.158.107.792.107.95 0l.634-.474c.83.56 2.11 1.42 2.865 1.924-.065.48-.485.866-.994.866H3.997a1 1 0 0 1-.986-.84zM3 5.26l2.439 1.63L3 8.549zm8 .007v3.274l-2.404-1.65zM10.003 4c.456 0 .849.312.963.736L7.182 7.254c-.159.107-.159.107-.317 0L3.04 4.71c.123-.407.504-.71.956-.71Z"
}))));
export default SvgChannelMail14;